// base_search 1.1
import { Search, } from "lucide-react"
import { Input, Button } from './ot'
import { useState, useEffect } from "react"
const KeywordSearchBox = ({
    value,
    placeholder = "關鍵字",
    onChange = () => { },
    onSearch = () => { },
    className = "",
    type = "text",
    searchButtonText ="查詢",
    ...props
}) => {
    // 搜索關鍵字

    return (<div className="flex items-center gap-2">
        <div className={`relative flex-1 min-w-[200px] ${className}`}>
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
            <Input
                type={type}
                placeholder={placeholder}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className="pl-10"
                {...props}
            />
        </div>
        <Button
            variant="outline" size="sm"
            onClick={() => {
                onSearch(value)
            }}>
            {searchButtonText}
        </Button>
    </div>)
}
export default KeywordSearchBox